<template>
  <v-container class="formulario-wrapper" fluid pa-0 fill-height>
    <div class="content-container elevation-2">
      <v-card class="d-flex flex-column fill-height">

        <div v-if="loading" class="text-center pa-8 flex-grow-1">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
          <p class="mt-4 mb-0">Carregando vendedores...</p>
        </div>

        <simplebar
          v-else-if="!loading && resultados.length > 0"
          data-simplebar
          :autoHide="false"
          class="lista-resultados-container flex-grow-1"
        >
          <v-list class="py-0">
            <template v-for="(item, index) in resultados">
              <v-list-item
                :key="item.codigo"
                class="resultado-item-clicavel"
                @click="itemClicado(item)"
              >
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium">
                    Código: {{ item.original.vencodigo }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text--primary mt-1">
                    Nome: {{ item.descricao }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle v-if="item.original.venidnuvem" class="mt-1">
                    IdVendedor: {{ item.original.venidnuvem }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                
                <v-list-item-action>
                  <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
                </v-list-item-action>
              </v-list-item>
              <v-divider v-if="index < resultados.length - 1" :key="`divider-${index}`"></v-divider>
            </template>
          </v-list>
        </simplebar>

        <div v-else class="text-center pa-8 flex-grow-1">
          <v-icon size="64" color="grey lighten-2">mdi-account-off</v-icon>
          <p class="mb-0 grey--text">Nenhum vendedor encontrado.</p>
        </div>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import simplebar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';
import db from '@/plugins/dexie';

export default {
  name: 'ViewPesquisaVendedorLista', 

  components: {
    simplebar,
  },

  data() {
    return {
      loading: false,
      resultados: [],
    };
  },

  watch: {
    '$route.query': {
      immediate: true,
      deep: true,
      handler() {
        this.carregarDados();
      },
    },
  },

  methods: {
    itemClicado(item) {
      const tipoQueChamou = this.$route.query.tipo || 'Vendedor';

      const codigoCorreto = item.original ? (item.original.venidnuvem || item.codigo) : (item.venidnuvem || item.codigo);
      const nomeCorreto = item.original ? (item.original.vennome || item.descricao) : (item.vennome || item.descricao);

      const payload = {
        tipo: tipoQueChamou,
        codigo: codigoCorreto,
        descricao: nomeCorreto,
        dadosExtras: {
          cpf: item.original ? item.original.vencpf : null
        }
      };

      sessionStorage.setItem('pesquisaResultado', JSON.stringify(payload));
      this.$router.back();
    },

    async carregarDados() {
      this.loading = true;

      const { codigo, descricao } = this.$route.query;

      const collection = db.vendedor;
      const idKey = 'venidnuvem';
      const descKey = 'vennome';

      try {
        let query = collection;

        if (codigo) {
          const idNum = parseInt(codigo, 10);
          if (!isNaN(idNum)) {
            query = collection.where(idKey).equals(idNum);
          } else {
            query = collection.where(idKey).equals(codigo);
          }
        } else if (descricao) {
          query = collection.where(descKey).startsWithIgnoreCase(descricao);
        } else {
          query = collection.limit(100);
        }

        const dadosDoBanco = await query.toArray();

        this.resultados = dadosDoBanco.map(item => {
          return {
            codigo: item[idKey],
            descricao: item[descKey],
            original: item 
          };
        });

      } catch (error) {
        console.error('Erro ao buscar vendedores:', error);
        this.resultados = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.formulario-wrapper {
  background-color: #f5f5f5;
}
.content-container {
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  height: 100%;  
  background: white;
}
.lista-resultados-container {
  overflow-y: auto;
}
.resultado-item-clicavel {
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
}
.resultado-item-clicavel:hover {
  background-color: #e3f2fd; 
}
</style>